import {Component, Vue} from "vue-property-decorator";

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

SimpleBar.removeObserver();

@Component
class Scroller extends Vue {

  // @see https://github.com/Grsmto/simplebar/blob/master/packages/simplebar/README.md#options
  protected scrollBar: SimpleBar = null;

  get scrollElement() : HTMLElement{
    return this.scrollBar ? this.scrollBar.getScrollElement() as HTMLElement : null;
  }

  get contentElement(): HTMLElement{
    return this.scrollBar ? this.scrollBar.getContentElement() as HTMLElement : null;
  }

  mounted(){
    this.start();
  }

  beforeDestroy(){
    this.stop();
  }

  update(){
    this.scrollBar.recalculate();
  }

  start(){
    this.scrollBar = new SimpleBar(this.$el, {
      clickOnTrack:true,
      autoHide:false,
    });
    this.scrollElement.addEventListener("scroll", this.emitScroll);
  }

  stop(){
    this.scrollElement.removeEventListener("scroll", this.emitScroll);
  }

  resetScrollPosition(){
    this.scrollElement.scrollTo(0, 0);
  }

  emitScroll(e) {
    this.$emit("scroll", {
      ...e,
      scroll: {
        y: this.scrollElement.scrollTop,
        x: this.scrollElement.scrollLeft,
      }
    });
  }

  scrollToBottom(){
    if( this.scrollElement){
      this.scrollElement.scrollTop = this.scrollElement.scrollHeight;
    }
  }

  render() {
    return (
      <div ref="element" class="scroller">
        {this.$slots.default}
      </div>
    );
  }

}

export {Scroller};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-117de3b4/scroller.tsx" });